import React from 'react';
import { Alert, Box, Button, Typography } from '@ublend-npm/aulaui-core';
import { EXISTING_SUBMISSION_CONFLICT_MESSAGES } from '../../constants';
import StudentRow from './StudentRow';
import {
  ExtensionStudent,
  ManageExtensionStyles,
} from './ManageExtension.types';

type Props = {
  errorCode: string;
  onClose: () => void;
  provider?: string;
  students: ExtensionStudent[];
  styles: ManageExtensionStyles;
};

const ExistingSubmissionConflict = ({
  errorCode,
  onClose,
  provider,
  students,
  styles,
}: Props) => {
  const currentExtensionConflict = errorCode === 'extension-submissions-exist';
  let message = currentExtensionConflict
    ? EXISTING_SUBMISSION_CONFLICT_MESSAGES.currentExtension
    : EXISTING_SUBMISSION_CONFLICT_MESSAGES.default;
  if (!currentExtensionConflict && provider === 'turnitin') {
    message = EXISTING_SUBMISSION_CONFLICT_MESSAGES.turnitin;
  }

  return (
    <Box sx={styles.conflictContent}>
      <Typography component="h3" sx={styles.conflictTitle}>
        {EXISTING_SUBMISSION_CONFLICT_MESSAGES.title}
      </Typography>
      <Alert severity="error">{message}</Alert>
      <Box component="ul" sx={styles.conflictStudents}>
        {students.map((student) => (
          <StudentRow
            key={student.id}
            canAdd={false}
            isSelected={false}
            onToggle={() => {}}
            showAction={false}
            student={student}
            styles={styles}
          />
        ))}
      </Box>
      <Box sx={styles.conflictActions}>
        <Button kind="secondary" onClick={onClose}>
          {EXISTING_SUBMISSION_CONFLICT_MESSAGES.close}
        </Button>
      </Box>
    </Box>
  );
};

export default ExistingSubmissionConflict;
